import { Form, Tooltip, DatePicker } from "antd";
import { Formik } from "formik";
import React from "react";
import CustomInput from "../../../../../components/customInput";
import PhoneInput from "react-phone-input-2";
import * as Yup from "yup";
import CustomLabel from "../../../../../components/customLabel";
import "./styles.scss";
import CustomModal from "../../../../../components/customModal";
import { crossIcon } from "../../../../../assets/svg";
import moment from "moment";
import useWindowDimensions from "../../../../../components/custom-hooks/useWindowDimensions";
import { MOBILE_WIDTH } from "../../../../../constants/constants";
import loginService from "../../../../../service/login";

const AddEditNumber = (props) => {
  const { userDetails, phone } = props;

  const { width } = useWindowDimensions();

  // const isEnableRcs = loginService.getEnableRcs();
  // const IsRcsEnableForLiveChat = loginService.getIsRcsForLiveChat();

  const addNewNumberSchema = Yup.object().shape({
    firstName: Yup.string()
      .required("First Name is required")
      .max(255, "First Name must not be more then 255 characters"),
    lastName: Yup.string()
      .required("First Name is required")
      .max(255, "Last Name must not be more then 255 characters"),
    phone: Yup.string().required("Phone Number is required"),
    dob: Yup.string().nullable(),
    mrn: Yup.string()
      .max(30, "MRN must not be more than 30 characters")
      .matches(/\S/, "Please enter only vaild characters"),
    countryCode: Yup.string().required("Country Code is required"),
  });

  return (
    <Formik
      enableReinitialize
      validateOnMount={true}
      initialValues={{
        firstName: userDetails.firstName || "",
        lastName: userDetails.lastName || "",
        mrn: userDetails.medicalRecordNumber || "",
        dob: userDetails?.dateOfBirth ? moment(userDetails.dateOfBirth) : null,
        phone,
        countryCode: userDetails.countryCode || "+1",
      }}
      validationSchema={addNewNumberSchema}
    >
      {({
        isValid,
        values,
        touched,
        errors,
        setFieldValue,
        setFieldTouched,
        dirty,
      }) => {
        const disableFutureDt = (current) => {
          return current && current > moment().add(0, "day");
        };

        return (
          <CustomModal
            title={
              <>
                {props.sideNavEdit ? "Edit Number" : "Add Number"}
                <Tooltip title="Close">
                  <span
                    className="close-icon-add-new"
                    onClick={props.closePopup}
                  >
                    {crossIcon}
                  </span>
                </Tooltip>
              </>
            }
            isVisible={true}
            disabled={!(isValid && (!props.sideNavEdit || dirty))}
            submitButtonText={props.sideNavEdit ? "Save" : "Add"}
            cancelButtonText="Cancel"
            handleDelete={() => props.setValues(values)}
            handleCancel={() => props.closePopup()}
          >
            <Form className="fields-wrapper">
              <section className="form-row add-new-number">
                <CustomInput
                  required
                  title="Patient First Name"
                  className="custom-form-input custom-form-input-add mt-2"
                  customClass="label-width"
                  placeholder="Enter Name"
                  name="firstName"
                />
              </section>
              <section className="form-row add-new-number">
                <CustomInput
                  required
                  title="Patient Last Name"
                  className="custom-form-input custom-form-input-add mt-2"
                  placeholder="Enter Name"
                  customClass="label-width"
                  name="lastName"
                />
              </section>

              <section
                className={
                  width > MOBILE_WIDTH
                    ? "form-row add-new-number mt-2"
                    : "form-row add-new-number"
                }
              >
                <>
                  <CustomLabel title="Date of Birth" customClass="dob-label" />
                  {width < MOBILE_WIDTH && <br />}
                  <DatePicker
                    className="add-date-picker"
                    format={["MM-DD-YYYY", "MM/DD/YYYY"]}
                    onChange={(value) => setFieldValue("dob", value)}
                    onBlur={() => setFieldTouched("dob", true)}
                    value={values.dob}
                    placeholder="MM-DD-YYYY or MM/DD/YYYY"
                    name="dob"
                    disabledDate={disableFutureDt}
                  />
                  {touched.dob && errors.dob ? (
                    <div className="error-label">{errors.dob}</div>
                  ) : null}
                </>
              </section>
              <section className="form-row add-new-number mt-2">
                <CustomInput
                  title="MR Number"
                  className="custom-form-input custom-form-input-add   mt-2"
                  placeholder="MR Number"
                  customClass="label-width"
                  name="mrn"
                />
              </section>

              <section className="form-row add-new-number mt-2">
                <CustomLabel
                  title="Country Code"
                  required
                  customClass="label-width"
                />
                <div className="mt-2">
                  <PhoneInput
                    country={"us"}
                    name="countryCode"
                    value={values.countryCode}
                    onChange={(value, countryData) => {
                      setFieldValue("countryCode", `+${countryData.dialCode}`);
                    }}
                    enableSearch={true}
                    inputStyle={{
                      width: "100px",
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                    buttonStyle={{
                      backgroundColor: "#fff",
                    }}
                    dropdownStyle={{ zIndex: 2000 }}
                    inputClass="country-code-only"
                    specialLabel=""
                    inputProps={{
                      readOnly: true,
                    }}
                  />
                </div>
              </section>

              <section className="form-row add-new-number mt-2">
                <CustomInput
                  required
                  title="Contact Number"
                  className="custom-form-input custom-form-input-add mt-2"
                  placeholder="Contact Number"
                  name="phone"
                  customClass="label-width"
                  disabled={true}
                />
              </section>
            </Form>
          </CustomModal>
        );
      }}
    </Formik>
  );
};

export default AddEditNumber;
